import { assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const removeFirstEncouragedChange: CustomizationMachineAction = assign((args) => {
  const { encouragedChangesList } = args.context;

  const [_, ...restEncouragedChanges] = encouragedChangesList;

  return { encouragedChangesList: restEncouragedChanges };
});
